import { Const } from '../lib/const.cls'

export const mutations = {
    [Const.SET_IP_ADDRESS_LIST](state, data) {
        try { state.ipAddressList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    // ======================= Login Info =========================
    [Const.SET_LOGIN_INFO](state, data) {
        try { state.loginInfo = data } catch (ex) { console.debug('set state EX', ex) }
    },

}


// WEBPACK FOOTER //
// ./src/plugins/userOperation/provider/store-addons/mutations.js